module.exports = __webpack_public_path__ + "img/Piece-18-3.c8f5e631.png";